import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_DELETE_INVESTMENT_TIMELINE } from "../../../config/api";

export const deleteInvestmentTimeline = createAsyncThunk(
  "InvestmentTimeline/DELETE",
  async (
    { cb, investment_id, timeline_id, failed, investment_type, cycle_id },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await Client({
        method: "DELETE",
        path:
          investment_type === "business"
            ? `${API_DELETE_INVESTMENT_TIMELINE}${investment_id}/${timeline_id}?investment_type=${investment_type}&cycle_id=${cycle_id}`
            : `${API_DELETE_INVESTMENT_TIMELINE}${investment_id}/${timeline_id}`,
      });
      toast.success("Timeline deleted successfully");

      cb();
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      failed();
      return rejectWithValue(error.message);
    }
  }
);
